// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Delete Modal Container */
.delete_deleteModal__Xl9XN {
  margin: 16px !important;
}

.delete_deleteModal__Xl9XN .MuiDialog-paper {
  margin: 16px !important;
  width: 100% !important;
  max-width: 540px !important;
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #e5e7eb !important;
}

/* Modal Header */
.delete_modalHeader__GSC3f {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding-bottom: 8px !important;
  border-bottom: 1px solid #f3f4f6 !important;
}

.delete_modalTitle__k9wvp {
  color: var(--Slate-700, #334155);

  /* Inter/Body xl/Body xl - semibold */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
}

.delete_closeButton__T3kHf {
  color: #6b7280 !important;
}

.delete_closeButton__T3kHf:hover {
  background-color: #f3f4f6 !important;
}

/* Modal Content */
.delete_modalContent__qEwog {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.delete_confirmationText__8Po8L {
  color: var(--Slate-800, #1e293b);

  /* Inter/Body md/Body md - medium */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}

.delete_warningText__q4yN2 {
  color: var(--Slate-500, #64748b);

  /* text-sm/leading-5/normal */
  font-family: var(--font-family-font-sans, Inter);
  font-size: text-sm;
  font-style: normal;
  font-weight: var(--font-weight-font-normal, 400);
  line-height: leading-5; /* 142.857% */
}

/* Modal Actions */
.delete_modalActions__nwbfv {
  padding: 24px 32px !important;
  /* padding-top: 8px !important; */
  border-top: 1px solid #f3f4f6 !important;
  gap: 16px !important;
}

/* Cancel Button */
.delete_cancelButton__FBqHS {
  border: none !important;
  color: #374151 !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 7px 24px !important;
  border-radius: 8px !important;
  background-color: rgba(241, 245, 249, 1) !important;
}

.delete_cancelButton__FBqHS:hover {
  border-color: #9ca3af !important;
  background-color: #e5e7eb !important;
}

/* Delete Button */
.delete_deleteButton__qg8pP {
  background-color: rgba(220, 38, 38, 1) !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 7px 24px !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

.delete_deleteButton__qg8pP:hover {
  background-color: rgba(200, 38, 38, 1) !important;
  box-shadow: none !important;
}

/* Delete Icon */
.delete_deleteIcon__0clVd {
  color: white !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .delete_deleteModal__Xl9XN .MuiDialog-paper {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
  }

  .delete_modalActions__nwbfv {
    padding: 8px 16px 16px 16px !important;
    gap: 12px !important;
  }

  .delete_cancelButton__FBqHS,
  .delete_deleteButton__qg8pP {
    padding: 10px 20px !important;
  }
}

/* ============================================================
   RESPONSIVE DESIGN
============================================================ */

/* ------------- Tablets (max-width: 900px) ------------- */
@media (max-width: 900px) {
  .delete_modalTitle__k9wvp {
    font-size: 18px;
  }
  .delete_confirmationText__8Po8L {
    font-size: 15px;
  }
}

/* ------------- Mobile (max-width: 600px) ------------- */
@media (max-width: 600px) {
  .delete_deleteModal__Xl9XN .MuiDialog-paper {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
  }

  .delete_modalContent__qEwog {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }

  .delete_modalActions__nwbfv {
    padding: 12px 16px !important;
    gap: 12px !important;
  }

  .delete_cancelButton__FBqHS,
  .delete_deleteButton__qg8pP {
    padding: 10px 18px !important;
    font-size: 14px !important;
  }

  .delete_modalHeader__GSC3f {
    padding-bottom: 6px !important;
  }

  .delete_modalTitle__k9wvp {
    font-size: 18px;
  }
}

/* ------------- VERY SMALL SCREENS (max-width: 380px) ------------- */
@media (max-width: 380px) {
  /* Stack buttons vertically */
  .delete_modalActions__nwbfv {
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .delete_cancelButton__FBqHS,
  .delete_deleteButton__qg8pP {
    width: 100% !important;
    padding: 12px !important;
  }

  .delete_modalTitle__k9wvp {
    font-size: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminDashboard/Hospital_Complaint/components/delete.module.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,gGAAgG;EAChG,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;;EAEhC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;;EAEhC,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,gCAAgC;;EAEhC,6BAA6B;EAC7B,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB,EAAE,aAAa;AACvC;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,iDAAiD;EACjD,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;;8DAE8D;;AAE9D,2DAA2D;AAC3D;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;;IAEE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sEAAsE;AACtE;EACE,6BAA6B;EAC7B;IACE,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Delete Modal Container */\n.deleteModal {\n  margin: 16px !important;\n}\n\n.deleteModal :global(.MuiDialog-paper) {\n  margin: 16px !important;\n  width: 100% !important;\n  max-width: 540px !important;\n  border-radius: 12px !important;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;\n  border: 1px solid #e5e7eb !important;\n}\n\n/* Modal Header */\n.modalHeader {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  padding-bottom: 8px !important;\n  border-bottom: 1px solid #f3f4f6 !important;\n}\n\n.modalTitle {\n  color: var(--Slate-700, #334155);\n\n  /* Inter/Body xl/Body xl - semibold */\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n}\n\n.closeButton {\n  color: #6b7280 !important;\n}\n\n.closeButton:hover {\n  background-color: #f3f4f6 !important;\n}\n\n/* Modal Content */\n.modalContent {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n\n.confirmationText {\n  color: var(--Slate-800, #1e293b);\n\n  /* Inter/Body md/Body md - medium */\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px; /* 150% */\n}\n\n.warningText {\n  color: var(--Slate-500, #64748b);\n\n  /* text-sm/leading-5/normal */\n  font-family: var(--font-family-font-sans, Inter);\n  font-size: text-sm;\n  font-style: normal;\n  font-weight: var(--font-weight-font-normal, 400);\n  line-height: leading-5; /* 142.857% */\n}\n\n/* Modal Actions */\n.modalActions {\n  padding: 24px 32px !important;\n  /* padding-top: 8px !important; */\n  border-top: 1px solid #f3f4f6 !important;\n  gap: 16px !important;\n}\n\n/* Cancel Button */\n.cancelButton {\n  border: none !important;\n  color: #374151 !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 7px 24px !important;\n  border-radius: 8px !important;\n  background-color: rgba(241, 245, 249, 1) !important;\n}\n\n.cancelButton:hover {\n  border-color: #9ca3af !important;\n  background-color: #e5e7eb !important;\n}\n\n/* Delete Button */\n.deleteButton {\n  background-color: rgba(220, 38, 38, 1) !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 7px 24px !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n}\n\n.deleteButton:hover {\n  background-color: rgba(200, 38, 38, 1) !important;\n  box-shadow: none !important;\n}\n\n/* Delete Icon */\n.deleteIcon {\n  color: white !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .deleteModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  .modalActions {\n    padding: 8px 16px 16px 16px !important;\n    gap: 12px !important;\n  }\n\n  .cancelButton,\n  .deleteButton {\n    padding: 10px 20px !important;\n  }\n}\n\n/* ============================================================\n   RESPONSIVE DESIGN\n============================================================ */\n\n/* ------------- Tablets (max-width: 900px) ------------- */\n@media (max-width: 900px) {\n  .modalTitle {\n    font-size: 18px;\n  }\n  .confirmationText {\n    font-size: 15px;\n  }\n}\n\n/* ------------- Mobile (max-width: 600px) ------------- */\n@media (max-width: 600px) {\n  .deleteModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  .modalContent {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n\n  .modalActions {\n    padding: 12px 16px !important;\n    gap: 12px !important;\n  }\n\n  .cancelButton,\n  .deleteButton {\n    padding: 10px 18px !important;\n    font-size: 14px !important;\n  }\n\n  .modalHeader {\n    padding-bottom: 6px !important;\n  }\n\n  .modalTitle {\n    font-size: 18px;\n  }\n}\n\n/* ------------- VERY SMALL SCREENS (max-width: 380px) ------------- */\n@media (max-width: 380px) {\n  /* Stack buttons vertically */\n  .modalActions {\n    flex-direction: column !important;\n    align-items: stretch !important;\n  }\n\n  .cancelButton,\n  .deleteButton {\n    width: 100% !important;\n    padding: 12px !important;\n  }\n\n  .modalTitle {\n    font-size: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteModal": `delete_deleteModal__Xl9XN`,
	"modalHeader": `delete_modalHeader__GSC3f`,
	"modalTitle": `delete_modalTitle__k9wvp`,
	"closeButton": `delete_closeButton__T3kHf`,
	"modalContent": `delete_modalContent__qEwog`,
	"confirmationText": `delete_confirmationText__8Po8L`,
	"warningText": `delete_warningText__q4yN2`,
	"modalActions": `delete_modalActions__nwbfv`,
	"cancelButton": `delete_cancelButton__FBqHS`,
	"deleteButton": `delete_deleteButton__qg8pP`,
	"deleteIcon": `delete_deleteIcon__0clVd`
};
export default ___CSS_LOADER_EXPORT___;
